// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"89307b6a","513":"af042e5c","703":"91a7d918"}[chunkId] + ".chunk.js";
};